<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0 back-image">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class>
            <div class="text-center">
              <div class="pt-4 pb-2 border-bottom">
                <h2>
                  {{ occupation.name }}
                  <span class="font-weight-light"></span>
                </h2>
                <div class="h6 font-weight-300">
                  <i class="ni location_pin mr-2"></i>
                  {{ occupation.Fam_Name }}
                </div>
              </div>
              <h4 class="pt-3">Automation risk index</h4>
              <div class="h6 font-weight-300">
                <i class="ni location_pin mr-2"></i>
              </div>

              <div class="h6 mt-1">
                <div class="speedometer text-center">
                  <vue-speedometer
                    :fluidWidth="true"
                    :value="(occupation.share_total * 1)"
                    :minValue="0.43"
                    :maxValue="0.78"
                    :maxSegmentLabels="5"
                    :needleTransitionDuration="1000"
                    needleTransition="easeQuadInOut"
                    currentValueText
                    :segments="1000"
                    startColor="#33CC33"
                    endColor="#FF471A"
                  ></vue-speedometer>
                </div>
                <i class="ni business_briefcase-24 mr-2"></i>
                <p>
                  Your job has an automation risk index of <br>
                  <span class="value">{{ (occupation.share_total * 1).toFixed(2) }}</span>
                </p>
                In our computations the automation risk index spans from 0.43 to 0.78.
                <br>
                <a href="/resiliencetorobots/#/doc/index">Learn how the automation risk is computed.</a>
              </div>
              <!-- <div><i class="ni education_hat mr-2"></i>University of Computer Science</div> -->
            </div>
            <div class="mt-5 py-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <h4>Resilient alternatives</h4>
                  <!-- <div class="h6 font-weight-300">
                    <i class="ni location_pin mr-2"></i>
                    PS: This is only a sample result
                  </div>-->
                  <div id="divId_options">
                    <tabs fill class="flex-column flex-md-row">
                      <card shadow>
                        <tab-pane>
                          <span slot="title">
                            <badge circle type="primary">1</badge>
                            <!-- &nbsp;&nbsp; {{(occupation.S_occ1)}} -->
                          </span>
                          <p style="font-size:16px;">
                            <em>
                              <strong>{{occupation.S_occ1}}</strong>
                            </em> is the first resilient alternative to
                            <em>
                              <strong>{{occupation.name}}</strong>
                            </em>
                            with an automation risk index of
                            <strong>{{(occupation.R_occ1 * 1).toFixed(2)}}</strong>.
                          </p>
                        </tab-pane>

                        <tab-pane title="Profile">
                          <span slot="title">
                            <badge circle type="primary">2</badge>
                            <!-- &nbsp;&nbsp; {{(occupation.S_occ2)}} -->
                          </span>
                          <p style="font-size:16px;">
                            <em>
                              <strong>{{occupation.S_occ2}}</strong>
                            </em> is the second resilient alternative to
                            <em>
                              <strong>{{occupation.name}}</strong>
                            </em>
                            with an automation risk index of
                            <strong>{{(occupation.R_occ2 * 1).toFixed(2)}}</strong>.
                          </p>
                        </tab-pane>

                        <tab-pane>
                          <span slot="title">
                            <badge circle type="primary">3</badge>
                            <!-- &nbsp;&nbsp; {{(occupation.S_occ3)}} -->
                          </span>
                          <p style="font-size:16px;">
                            <em>
                              <strong>{{occupation.S_occ3}}</strong>
                            </em> is the third resilient alternative to
                            <em>
                              <strong>{{occupation.name}}</strong>
                            </em>
                            with an automation risk index of
                            <strong>{{(occupation.R_occ3 * 1).toFixed(2)}}</strong>.
                          </p>
                        </tab-pane>
                      </card>
                    </tabs>
                  </div>
                  <div id="divId_message">
                      <card shadow>
                          <p style="font-size:16px;">
                            <em>
                              <strong>{{occupation.name}}</strong>
                            </em> already has a low automation risk index. Thus, it does not have any reasonable alternative jobs. 
                          </p>
                      </card>
                  </div>
                  <!-- <p>An artist of considerable range, Ryan — the name taken by Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs and records all of his own music, giving it a warm, intimate feel with a solid groove structure. An artist of considerable range.</p> -->
                  <!-- <p>{{occupation}}</p> -->
                  <div class="pt-4">
                    <p style="font-size:14px">The ranking of the 3 alternatives takes into account both the retraining effort and the automation risk reduction. <br>The top alternative is not necessarily the one that offers the largest reduction in automation risk.</p>
                    <a
                      href="/resiliencetorobots/#/doc/res-index"
                    >Learn how the resilient alternative jobs are found. </a> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>
<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import VueSpeedometer from "vue-speedometer";
export default {
  components: {
    Tabs,
    TabPane,
    VueSpeedometer
  },
  created() {
    console.log(this.$route.params.occupation);
    this.occupation = this.$route.params.occupation;
    if (this.occupation === undefined) {
      console.log("Undefined Occupation");
      this.$router.push({ name: "home" });
    } else { // THIS IS NEW
      var occupation = this.$route.params.occupation;
      var checkExist = setInterval(function() {
        console.log("Checking...");
        if (document.getElementById("divId_options") != null &&  document.getElementById("divId_message") != null) {
          console.log("This occupation is ranked as number", occupation.id);
          clearInterval(checkExist);
          if (occupation.id >= 965) {
            console.log("This occupation has low risk ");
            document.getElementById("divId_options").style.display = "none";
          } else {
            console.log("This occupation has high risk");
            document.getElementById("divId_message").style.display = "none";
          }
        }
      }, 100); // check every 100ms
    }
  },
  data() {
    return {
      occupation: this.$route.params.occupation,
      toggle: false
    };
  },
  methods: {}
};
</script>
<style>
.value {
  letter-spacing: 0.025em;
  font-size: 1.95rem;
  text-transform: uppercase;
  font-weight: 500;
}
.speedometer {
  width: 310px;
  height: 170px;
  margin: 0 auto;
}
/* .back-image {
   background-image: url(/img/theme/technology-and-jobs.jpg); 
} */
</style>
